import api from 'service/api'

const dponetAPI = api.create('supplierPortal', false)

const get = async () => {
  return await dponetAPI.get(`/company_supplier_questionnaire_users`)
}

const create = async ({ id = '', ...params }) => {
  return await dponetAPI.post('/company_supplier_questionnaire_users', {
    companySupplierQuestionnaireUser: params,
  })
}

const destroy = async ({ companySupplierAuditUserId = '', id = '' }) => {
  return await dponetAPI.delete(
    `/company_supplier_audit_users/${companySupplierAuditUserId}/company_supplier_questionnaire_users/${id}`,
  )
}

export default { get, create, destroy }
